import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ReactGA from "react-ga4";
import axios from "axios";
import ReactPixel from "react-facebook-pixel";

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-width: 500px;
`;

const ModalTitle = styled.h2`
  text-align: center;
  margin-bottom: 20px;
  font-size: 20px;
`;

const PlanSelection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const PlanButton = styled.button`
  flex: 1;
  padding: 10px;
  border: 2px solid
    ${(props) => (props.selected ? "rgb(88, 80, 236)" : "#e9e9e9")};
  background-color: ${(props) =>
    props.selected ? "rgb(229, 237, 255)" : "white"};
  color: ${(props) => (props.selected ? "rgba(88, 80, 236, 1)" : "black")};
  border-radius: 5px;
  cursor: pointer;
  margin: 0 5px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

const EmailInput = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: rgb(88, 80, 236);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const BottomForm = ({ selectedPlan = "スタンダード", isOpen, onClose }) => {
  const [currentPlan, setCurrentPlan] = useState(selectedPlan);
  const [email, setEmail] = useState("");

  useEffect(() => {
    setCurrentPlan(selectedPlan);
  }, [selectedPlan]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handlePlanSelect = (plan) => {
    setCurrentPlan(plan);
  };

  const handleSubmit = async () => {
    if (!email) {
      alert("メールアドレスを入力してください");
      return;
    }

    // 이메일 형식 검증을 위한 정규 표현식
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!emailRegex.test(email)) {
      alert("유효한 이메일 주소를 입력해 주세요.");
      return;
    }

    try {
      const response = await axios.post("https://api.qtapp.kr/nooru", {
        email: email,
        type: currentPlan,
      });
      if (response.status === 200 || response.status === 201) {
        console.log("選択されたプラン:", currentPlan);
        console.log("メールアドレス:", email);
        ReactGA.event({
          category: "Form",
          action: "Submit",
          label: `Plan: ${currentPlan}, Email: ${email}`,
        });

        // Facebook Pixel 전환 이벤트
        ReactPixel.track("SubmitApplication", {
          content_name: "Application Form",
          content_category: "Form Submission",
          value: 1,
          currency: "JPY",
          status: "success",
          plan: currentPlan,
        });

        onClose();
        setEmail("");
        setCurrentPlan("スタンダード");
        alert(
          "お申し込みが完了しました。サービスオープン時にご連絡いたします。ありがとうございます。"
        );
      } else {
        alert("申し込み中にエラーが発生しました。もう一度お試しください。");
      }
    } catch (error) {
      console.error("API リクエスト失敗:", error);
      alert("申し込み中にエラーが発生しました。もう一度お試しください。");
    }
  };

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <ModalBackground onClick={handleBackgroundClick}>
      <ModalContent>
        <ModalTitle>事前申込</ModalTitle>
        <PlanSelection>
          <PlanButton
            selected={currentPlan === "ライト"}
            onClick={() => handlePlanSelect("ライト")}
          >
            ライト
          </PlanButton>
          <PlanButton
            selected={currentPlan === "スタンダード"}
            onClick={() => handlePlanSelect("スタンダード")}
          >
            スタンダード
          </PlanButton>
          <PlanButton
            selected={currentPlan === "プレミアム"}
            onClick={() => handlePlanSelect("プレミアム")}
          >
            プレミアム
          </PlanButton>
        </PlanSelection>
        <EmailInput
          type="email"
          placeholder="メールアドレスを入力してください"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <SubmitButton onClick={handleSubmit}>提出</SubmitButton>
      </ModalContent>
    </ModalBackground>
  );
};

export default BottomForm;
